
class ThemesPlugin {
	install(Vue, options) {
		Vue.mixin({
			mounted() {
				let style = document.querySelector('[role="theme"]');
				if(style) {
					let head = document.querySelector('head');
					head.appendChild(style);
				}
			}
		});
	}
}

export default new ThemesPlugin();





// WEBPACK FOOTER //
// ../common/plugins/themesPlugin.js